
<template>

<div v-bind:style="styleObject" >
 
     <v-modal title="提示信息"
             :visible="visible"
             @ok="handleOk"
             @cancel="handleCancel">
        <p>请您再次核对开票信息，如需重开发票需等待5-7个工作日。</p>
        <p>申请开票后，发票将在2个工作日左右发送到您的邮箱。</p>
        <p>请耐心等待。</p>
       
    </v-modal>
  <v-form direction="horizontal" :model="param" :rules="rules"  ref="param">
    <div style="text-align:center">
         <div class="logo" style="padding-top:5px;margin-bottom:5px;">
          
            <!-- <h2 style="float:left">开票申请</h2> -->
            <div style=" margin:0 auto; width:400px;">
               <img style="width:100px;height:50px; float:left;" src="../../../static/other/vfs-global-logo.svg" />
               <b style="font-size:30px;float:left;padding:0px 40px 0px 40px">开票申请</b>
                <!-- <img style="width:100px;height:50px;float:right;" src="../../../static/other/twenty-year-logo.svg" /> -->
            </div>
          
          
         </div>
   </div>
   
   <v-form-item label="支付方式" style="clear:both" :label-col="labelCol" :wrapper-col="wrapperCol">
        <v-radio-group v-model="param.fkfs" :data="pay_type"></v-radio-group> <strong style="font-size:11pt;color:#EC7008;float:right">建议签收护照后，5-7个工作日再申请开票。</strong>
    </v-form-item>
     <v-form-item label="收据号码"  :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test"  required >
      <v-input  placeholder="请输入收据号码" v-model="param.ywdh" size="large"></v-input>
    </v-form-item>
     <v-form-item label="UID"  :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test"  required >
      <v-input  placeholder="请输入UID" v-model="param.uid" size="large"></v-input>
    </v-form-item>
    <v-form-item label="受票方" v-show="invoice_type_change" :label-col="labelCol" :wrapper-col="wrapperCol"  >
       <v-radio-group v-model="param.sqrlx" :data="type" @change="change"></v-radio-group>
    </v-form-item>
    <v-form-item :label="title" :label-col="labelCol" :wrapper-col="wrapperCol" prop="sqrmc"  required has-feedback>
       <v-input  :placeholder="plac_title" v-model="param.sqrmc" size="large"></v-input>
    </v-form-item>
    <v-form-item label="企业税号" v-show="type_change" :label-col="labelCol" :wrapper-col="wrapperCol" required>
      <v-input  placeholder="请输入企业税号" v-model="param.qysh" size="large"></v-input>
    </v-form-item>
     <!-- <v-form-item label="注册地址" v-show="type_change" :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test" >
      <v-input  :placeholder="address" v-model="param.addr" size="large"></v-input>
    </v-form-item>
     <v-form-item label="注册电话" v-show="type_change" :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test">
      <v-input  :placeholder="tel" v-model="param.tel" size="large"></v-input>
    </v-form-item>
     <v-form-item label="开户银行" v-show="type_change" :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test">
      <v-input  :placeholder="bank" v-model="param.bank" size="large"></v-input>
    </v-form-item>
      <v-form-item label="银行账号" v-show="type_change" :label-col="labelCol" :wrapper-col="wrapperCol" v-bind="test">
      <v-input  :placeholder="number" v-model="param.num" size="large"></v-input>
    </v-form-item> -->
     </v-form-item>
     <v-form-item label="联系电话" :label-col="labelCol" :wrapper-col="wrapperCol"  prop="lxdh" has-feedback>
      <v-input  placeholder="(可选填)" v-model="param.lxdh" size="large" ></v-input>
    </v-form-item>
     <v-form-item label="邮箱" :label-col="labelCol" :wrapper-col="wrapperCol" required >
      <v-input  placeholder="请输入邮箱" v-model="param.sqryx" size="large"></v-input>
    </v-form-item>
     <div style="text-align:center">
    <v-form-item  >
      <v-button type="primary" html-type="submit" :disabled="flag"  @click.prevent="submitForm('param')" >申请开票</v-button>
    </v-form-item>
     </div>
  </v-form>
  
   </div>
</template>

<style scoped>
</style>
<script>
import axios from "axios";

let param = {
  fkfs: "1",
  sqrlx: "1",
  ywdh: "",
  uid: "",
  sqrmc: "个人",
  qysh: "",
  //   addr:"",
  //   tel:"",
  //   bank:"",
  //   num:"",
  lxdh: "",
  sqryx: "",
}

let type = [{ value: '1', text: '个人' }, { value: '2', text: '企业' }];
let pay_type = [{ value: '1', text: '中信银行' }, { value: '2', text: 'EMS邮政' }];

//  let checklxdh = (rule, value, callback) => {
//       setTimeout(() => {
//         if(value!= undefined && value!=""){
//            if (isNaN(value)) {
//           callback(new Error("手机号必须是数字!"));
//           } else {
//                 if (value.length != 11) {
//                   callback(new Error("手机号输入未满11位!"));
//                 } else {
//                   callback();
//                 }
//           }
//         }

//       }, 1000);
//     };

let options = [{ label: "增值税电子普通发票", value: "026" }, { label: "增值税电子专用发票", value: "028" }]

export default {
  data() {
    return {
      visible: false,
      flag: false,
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      type,

      pay_type,

      styleObject: { height: 'auto' },
      type_change: false,
      msg: "",
      test: null,
      //    address:"(非必填)",
      //    tel:"(非必填)",
      //    bank:"(非必填)",
      //    number:"(非必填)",
      img_src: "",
      title: "发票抬头",
      plac_title: "请输入发票抬头",
      invoice_type_change: true,
      param,
      options,
      rules: {
        // sqrmc: [{
        //     required: true,
        //     message: '必填字段'
        // }],
        // lxdh: [{
        //     validator: checklxdh
        //   }],
      },
    }
  },
  created() {
    
  },
  methods: {
  
    handleOk() {
      this.visible = false;
      this.submitForm('param',2)
    },
    handleCancel() {
      this.visible = false;
    },
    change_type(val) {
      if (val == "026") {
        this.invoice_type_change = true;
        this.type_change = false;
        this.title = "发票抬头";
        this.plac_title = "请输入发票抬头"
        this.styleObject = { height: 'auto' }
        this.address = "(非必填)"
        this.tel = "(非必填)"
        this.bank = "(非必填)"
        this.number = "(非必填)"
        this.test = null
        this.param.sqrlx = "1"
      } else {
        this.invoice_type_change = false;
        this.type_change = true;
        this.title = "企业名称";
        this.plac_title = "请输入企业名称"
        this.styleObject = { height: window.screen.height + 50 + "px" }
        this.address = "请输入注册地址"
        this.tel = "请输入注册电话"
        this.bank = "请输入开户银行"
        this.number = "请输入银行账号"
        this.test = { required: true };
        this.param.sqrlx = "2"
      }
      this.param.ywdh = ""
      this.param.uid = ""
      this.param.sqrmc = ""
      this.param.qysh = ""
      //  this.param.addr =""
      //  this.param.tel =""
      //  this.param.bank =""
      //  this.param.num =""
      this.param.lxdh = ""
      this.param.sqryx = ""
      this.param.sqrmc = ""

    },
    submitForm(formName,index=1) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.param.ywdh == undefined || this.param.ywdh == "") {
            this.$message["error"]("请输入业务流水号！", 5);
            return false;
          }

          if (this.param.ywdh != undefined && this.param.ywdh != "" && this.param.ywdh.length != 13 && this.param.ywdh.length != 16) {
            this.$message["error"]("业务流水号正确格式为13或16位！", 5);
            return false;
          }
          if (this.param.uid == undefined || this.param.uid == "") {
            this.$message["error"]("请输入UID！", 5);
            return false;
          }
          if (this.param.uid != undefined && this.param.uid != "" && this.param.uid.length != 8 && this.param.uid.length != 9) {
            this.$message["error"]("UID正确格式为8位或9位！", 5);
            return false;
          }
          if (this.param.sqrmc == undefined || this.param.sqrmc == "") {
            if (this.param.sqrlx == "1") {
              this.$message["error"]("请输入发票抬头！", 5);
            } else {
              this.$message["error"]("请输入企业名称！", 5);
            }
            return false;
          }
          if (this.param.sqrlx == "2" && (this.param.qysh == undefined || this.param.qysh == "")) {
            this.$message["error"]("请输入企业税号！", 5);
            return false;
          }
          if (this.param.sqrlx == "2" && this.param.qysh != undefined && this.param.qysh != "") {
            var reg = /^[0-9A-Za-z]{6,24}$/;
            if (!reg.test(this.param.qysh)) {
              this.$message["error"]("请输入正确格式的企业税号！", 5);
              return false;
            }
          }

          if (this.param.lxdh != undefined && this.param.lxdh != "" && this.param.lxdh.length < 11) {
            this.$message["error"]("请输入正确的购方联系人电话！", 5);
            return false;
          }

          if (this.param.sqryx == undefined || this.param.sqryx == "") {
            this.$message["error"]("请输入邮箱！", 5);
            return false;
          }
          var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (this.param.sqryx != undefined && this.param.sqryx != "" && !reg.test(this.param.sqryx)) {
            this.$message["error"]("请输入正确的购方电子邮箱！", 5);
            return false;
          }
          if(index ==1){
            this.visible = true
            return
          }
          this.flag = true
          axios
            .post("api/system/interface/fp-kpsq", this.param)
            .then(res => {
              if (res.data.rtnqysh == "0000") {
                this.$message["success"](res.data.rtnmsg, 5);
                this.$router.push("/send");
              } else {
                this.$message["error"](res.data.rtnmsg, 5);
                this.flag = false
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    change(selectValue) {
      debugger
      this.param.sqrmc = "";
      this.param.sqryx = "";
      this.param.lxdh = "";
      this.param.qysh = "";
      if (selectValue == "2") {
        this.type_change = true;
        this.title = "企业名称";
        this.plac_title = "请输入企业名称"
        this.styleObject = { height: window.screen.height + 50 + "px" }

      } else {
        this.type_change = false;
        this.title = "发票抬头";
        this.plac_title = "请输入发票抬头"
        this.styleObject = { height: 'auto' }
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/view/ywgl/invoice.vue